import { render, staticRenderFns } from "./GenericNode.vue?vue&type=template&id=5c3da416"
import script from "./GenericNode.vue?vue&type=script&lang=js"
export * from "./GenericNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports